import connectionsStore, { ConsumerKind3 } from "@mobx/store/connections";
import { MutableRefObject, useEffect, useMemo } from "react";
import usePlaceID3 from "./usePlaceID";
import { useIsSelectedForDrag3 } from "./useSelectedForDrag";

const dragToggleRegistry3 = new Map<string, () => void>();

export const toggleSchemeDragItemByID3 = (dragID: string) => {
  dragToggleRegistry3.get(dragID)?.();
};

export const useSchemeDragItem3 = (kind: ConsumerKind3, id: string, el: MutableRefObject<HTMLElement | null>, info: unknown) => {
  const isSelectedForSchemeDrag = useIsSelectedForDrag3(id, kind);
  const dragID = useMemo(() => `${kind}#${id}`, [kind, id]);
  const { placeID } = usePlaceID3(true);
  const dragStore = useMemo(() => placeID ? (connectionsStore.getPlaceStore(placeID)?.drag) : undefined, [placeID]);

  useEffect(() => {
    const toggle = () => dragStore?.toggleToDrag(id, kind, dragID, info);
    dragToggleRegistry3.set(dragID, toggle);
    return () => {
      if (dragToggleRegistry3.get(dragID) === toggle) {
        dragToggleRegistry3.delete(dragID);
      }
    };
  }, [dragID, dragStore, id, info, kind]);

  useEffect(() => {
    if (!isSelectedForSchemeDrag || !placeID) return;

    const onKeyDown = (ev: KeyboardEvent) => {
      if (ev.key !== "Escape") return;
      connectionsStore.getPlaceStore(placeID)?.clearDrag();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isSelectedForSchemeDrag, placeID]);

  return {
    isSelectedForSchemeDrag,
    dragID,

    mouseDown(e: React.MouseEvent<HTMLElement>) {
      if (e.ctrlKey) {
        const innerDragEl = (e.target as HTMLElement | null)?.closest?.("[data-drag-id]") as HTMLElement | null;
        const innerDragID = innerDragEl?.getAttribute("data-drag-id");
        if (innerDragID && innerDragID !== dragID) return;
        toggleSchemeDragItemByID3(dragID);
      }
    }
  }
}
